module.exports = __webpack_public_path__ + "static/media/christmas.6e42cb76.jpg";